module.exports = __webpack_public_path__ + "img/shop.20bbf325.png";